import { Component } from '@angular/core';
import {BaseState} from '@base/entities/BaseEntities';
import {BaseComponent} from '@base/component/BaseComponent';
import {ServiceBagService} from '@base/component/ServiceBag';
import { IBottomSheetComponent } from '@m4u-angular/core/framework/bottom-sheet.service';
import { BottomSheetDialogComponent } from '@m4u-angular/ui/dialogs/bottom-sheet-dialog/bottom-sheet-dialog.component';

class State extends BaseState {
    Value: number = 0;
}

@Component({
    selector: 'app-demo-buttons',
    templateUrl: './demo-buttons.component.html',
    styleUrls: ['../../styles/demo-styles.scss']
})
export class DemoButtonsComponent extends BaseComponent<State> implements IBottomSheetComponent {
    Context: BottomSheetDialogComponent;
    
    constructor(A: ServiceBagService) {
        super(A, 'DemoButtonsComponent', State);
    }
    

    public OnButtonClicked() {
        this.State.Value++;
    }
}
